import { ViewFactory } from 'wdc-cube-react'
import GroupManagerFormScope, { HeaderScope } from '../gm_form_scope'
import GroupManagerFormView from './gm_form_view'
import HeaderView from './gm_form-header'

export function registerViews(rv = ViewFactory.register) {
    rv(GroupManagerFormScope, GroupManagerFormView)
    rv(HeaderScope, HeaderView)
}
